export default {
  LOAD_STUDY_PROGRAM_CASE_FORM_PAGE_START: 'LoadStudyProgramCaseFormPageStart',
  LOAD_STUDY_PROGRAM_CASE_FORM_PAGE_END: 'LoadStudyProgramCaseFormPageEnd'
};